import React from 'react';
import { Route, Redirect } from 'react-router-dom';
import { AuthStore } from '../stores/Auth';

export const PublicOnlyRoute = ({ component: Component, ...rest }: any) => {
  return (
    <Route {...rest} render={props => (
      !AuthStore.authenticated ? (
        <Component {...props} />
      ) : (
          <Redirect to={{
            pathname: '/',
            state: { from: props.location }
          }} />
        )
    )} />
  );
};